import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../../Components/baseUrl";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.css";
import Menu from "../../Components/Menu";

const Confirmed = () => {
    const navigate = useNavigate();
    let token;
    if (typeof window !== "undefined") {
        token = localStorage.getItem("token");
    }
    useEffect(() => {
        document.title = "پایا | تایید شده";
        token == null && navigate("/login", { replace: true });
    }, []);
    const [loading, setLoading] = useState(true);
    const [list, setList] = useState([]);
    useEffect(() => {
        let status = {
            status: [5],
        };
        let config = {
            url: `${baseUrl}/orders/get-orders-by-status`,
            method: "POST",
            data: status,
        };
        axios(config)
            .then((res) => {
                res && res.data && res.data.data && setList(res.data.data);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    }, []);
    const [searchText, setSearchText] = useState("");
    const searchOrder = (e) => {
        let config = {
            url: `${baseUrl}/orders?search=${searchText}&status=1`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                res && res.data && res.data.data && setList(res.data.data);
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    return (
        <div className="container">
            <div className="search-box" id="search_box">
                <div className="pos-rel-search">
                    <input
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        type="text"
                        placeholder="جستجو کنید"
                    />
                    <svg
                        onClick={() => searchOrder()}
                        className="search-svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M18.5831 13.5489C19.204 11.7018 19.1293 9.69155 18.3731 7.89557C17.6169 6.09959 16.2312 4.64137 14.4761 3.79465C12.7209 2.94793 10.7171 2.77094 8.84074 3.29691C6.96438 3.82287 5.3445 5.01562 4.28521 6.65125C3.22592 8.28688 2.80005 10.2529 3.08754 12.1803C3.37504 14.1076 4.35614 15.8638 5.84666 17.1191C7.33718 18.3744 9.23463 19.0424 11.1828 18.9979C13.131 18.9534 14.9959 18.1993 16.4275 16.8772"
                            stroke="#A2A2A2"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M16.5 16.958L21.5 21.958"
                            stroke="#A2A2A2"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
            </div>
            {loading ? (
                <div className="emp-main">
                    <img src="/assets/images/loading.gif" width={50} />
                </div>
            ) : list && list.length !== 0 ? (
                <div className="orders-main">
                    <h1>سفارشات تایید شده</h1>
                    {list &&
                        list.length !== 0 &&
                        list.map((item) => {
                            if (item.Status == "تایید شده") {
                                return (
                                    <a
                                        className="orders-card"
                                        onClick={(e) => {
                                            navigate(
                                                "/panel/factor/" + item.id
                                            );
                                        }}
                                    >
                                        <img
                                            src={
                                                item.company.avatar
                                                    ? item.company.avatar
                                                    : "/assets/images/logo.svg"
                                            }
                                            alt=""
                                        />
                                        <div>
                                            <span className="name">
                                                {item.company.store_name}
                                            </span>
                                            <span className="fullname">
                                                {item.company.name}{" "}
                                            </span>
                                            <span className="numb">
                                                {item.code}
                                            </span>
                                            <div className="dates">
                                                <button>{item.Status}</button>
                                                <span>{item.Created_at}</span>
                                            </div>
                                        </div>
                                    </a>
                                );
                            }
                        })}
                </div>
            ) : (
                <div className="emp-main">
                    <svg
                        width="145"
                        height="145"
                        viewBox="0 0 145 145"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            opacity="0.4"
                            d="M64.9479 14.8021C69.1167 11.2375 75.9438 11.2375 80.1729 14.8021L89.7188 23.0188C91.5313 24.5896 94.9146 25.8584 97.3313 25.8584H107.602C114.006 25.8584 119.263 31.1146 119.263 37.5188V47.7896C119.263 50.1459 120.531 53.5896 122.102 55.4021L130.319 64.9479C133.883 69.1167 133.883 75.9438 130.319 80.1729L122.102 89.7188C120.531 91.5313 119.263 94.9146 119.263 97.3313V107.602C119.263 114.006 114.006 119.263 107.602 119.263H97.3313C94.975 119.263 91.5313 120.531 89.7188 122.102L80.1729 130.319C76.0042 133.883 69.1771 133.883 64.9479 130.319L55.4021 122.102C53.5896 120.531 50.2062 119.263 47.7896 119.263H37.3375C30.9333 119.263 25.6771 114.006 25.6771 107.602V97.2709C25.6771 94.9146 24.4083 91.5313 22.8979 89.7188L14.7417 80.1125C11.2375 75.9438 11.2375 69.1771 14.7417 65.0084L22.8979 55.4021C24.4083 53.5896 25.6771 50.2063 25.6771 47.85V37.4583C25.6771 31.0542 30.9333 25.7979 37.3375 25.7979H47.7896C50.1458 25.7979 53.5896 24.5292 55.4021 22.9583L64.9479 14.8021Z"
                            fill="#6BBD4E"
                        />
                        <path
                            d="M65.1896 91.6521C63.9812 91.6521 62.8333 91.1688 61.9875 90.3229L47.3667 75.7021C45.6146 73.95 45.6146 71.05 47.3667 69.2979C49.1187 67.5459 52.0187 67.5459 53.7708 69.2979L65.1896 80.7167L91.1687 54.7375C92.9208 52.9854 95.8208 52.9854 97.5729 54.7375C99.325 56.4896 99.325 59.3896 97.5729 61.1417L68.3917 90.3229C67.5458 91.1688 66.3979 91.6521 65.1896 91.6521Z"
                            fill="#6BBD4E"
                        />
                    </svg>
                    <p className="emp-text">
                        هیچ سفارش تایید شده ای ثبت نشده است
                    </p>
                </div>
            )}
            <Menu active="cart" />
        </div>
    );
};

export default Confirmed;
